import { generatePath, matchPath } from 'react-router-dom';
import type { Funnelable } from '../types';
import { Funnel } from '../types';

export class DistributionLocations implements Funnelable {
  routeSegment = 'release';

  funnels = [Funnel.DISTRIBUTION];

  pathname = `/${this.routeSegment}/:releaseId`;

  artistName = {
    pathname: (releaseId: string) =>
      generatePath(`${this.pathname}/${this.artistName.route}`, {
        releaseId,
      }),
    route: 'artist-name',
  };

  tracklist = {
    pathname: (releaseId: string) =>
      generatePath(`${this.pathname}/${this.tracklist.route}`, {
        releaseId,
      }),
    route: 'tracklist',
  };

  details = {
    pathname: (releaseId: string) =>
      generatePath(`${this.pathname}/${this.details.route}`, {
        releaseId,
      }),
    route: 'details',
  };

  review = {
    pathname: (releaseId: string) =>
      generatePath(`${this.pathname}/${this.review.route}`, {
        releaseId,
      }),
    route: 'review',
  };

  funnelsForPathname(pathname: string) {
    if (matchPath(`${this.routeSegment}/*`, pathname)) {
      return this.funnels;
    }
    return null;
  }
}
